import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pc-red.png'
import _imports_1 from '@/assets/pc-blue.png'


const _withScopeId = n => (_pushScopeId("data-v-49395a98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "start__page" }
const _hoisted_2 = { class: "blur-box left-blur" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "blur__image"
}, null, -1))
const _hoisted_4 = { class: "start__page-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "start__page-header" }, "Соберём сервер вместе", -1))
const _hoisted_6 = { class: "blur-box right-blur" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "blur__image"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tp_slider = _resolveComponent("tp-slider")!
  const _component_tp_blur_button = _resolveComponent("tp-blur-button")!
  const _component_tp_link_arrow = _resolveComponent("tp-link-arrow")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tp_box = _resolveComponent("tp-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tp_box, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "blur__background left-blur__background",
            style: _normalizeStyle(`background: url(${require('@/assets/red-blur.svg')}) no-repeat center`)
          }, null, 4),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_tp_slider),
          _createVNode(_component_tp_blur_button, { class: "start__page-button" }, {
            default: _withCtx(() => [
              _createTextVNode("Играть")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "start__page-help",
            to: { path: 'help' }
          }, {
            default: _withCtx(() => [
              _createTextVNode("Правила "),
              _createVNode(_component_tp_link_arrow, { color: "#fff" })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "blur__background right-blur__background",
            style: _normalizeStyle(`background: url(${require('@/assets/blue-blur.svg')}) no-repeat center`)
          }, null, 4),
          _hoisted_7
        ])
      ]),
      _: 1
    })
  ]))
}